import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Calculator = createSvgIcon(
  <path d="M2.25 24V0h19.5v24H2.25Zm12-2.25V18H10.5v3.75h3.75Zm2.25 0h3V12h-3v9.75Zm-2.25-6V12H10.5v3.75h3.75Zm5.25-6v-7.5h-15v7.5h15Zm-15 12h3.75V18H4.5v3.75Zm0-6h3.75V12H4.5v3.75Z" />,
  'Calculator'
);

export { Calculator };